module.exports = __webpack_public_path__ + "img/user-profile-picture-placeholder.54bae175.png";